import { Tooltip } from 'antd';
import { Button } from 'antd';

import { CopyOutlined } from '@ant-design/icons';

const ShowIntentsBtn = (props) => {
  return (
    <Tooltip title={props.tooltip || "Prikaži transakcije"}>
      <Button size={props.size || "small"}><CopyOutlined /></Button>
    </Tooltip>
  );
};

export default ShowIntentsBtn;
